import axios from "axios";
import { Fragment, useState } from "react";
import React from "react";
import { Disclosure } from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import mainLogo from "../mglogo.png";

import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  ShoppingBagIcon,
  ClipboardIcon,
  TableIcon,
  ArchiveIcon,
  DocumentIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ScaleIcon,
  ShoppingCartIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";


const navigation = [
  {
    id:1,
    name: "Dashboard",
    href: "/crm/filterby/Dashboard",
    icon: HomeIcon,
    current: false,
    defaultOpen:"",
  },
  {
    id:2,
    name: "Employee",
    href: "/crm/filterby/Employeelist",
    icon: UsersIcon,
    current: false,
    defaultOpen:"",
  },
  {
    id:3,
    name: "Item",
    href: "/crm/filterby/ItemList",
    icon: ShoppingBagIcon,
    current: false,
    defaultOpen:"",
  },
  { id:4,name: "Lead", href: "/crm/filterby/LeadList", icon: ClipboardIcon, current: false,defaultOpen:"", },
  {
    id:5,
    name: "Branch",
    href: "/crm/filterby/BranchList",
    icon: TemplateIcon,
    current: false,
    defaultOpen:"",
  },
  {
    id:7,
    name: "Expense",
    href: "/crm/filterby/ExpenseList",
    icon: ColorSwatchIcon,
    current: false,
    defaultOpen:"",
  },
  {
    id:8,
    name: "Sales",
    current: false,
    icon: ShoppingBagIcon,
    defaultOpen:"",
    children: [
      {name: "Customer", href: "/crm/filterby/Customerlist",},
      { name: "Invoice", href: "/crm/filterby/Invoicelist", },
      { name: "CustomerFeedback", href: "/crm/filterby/InvoiceFeedbacklist", },
      
    ],
  },
  {
    id:9,
    name: "Purchases",
    current: false,
    icon:ShoppingCartIcon,
    defaultOpen:"",
    children: [
      { name: "Vendor",href: "/crm/filterby/Vendorslist",},
      { name: "Purchase Order", href: "/crm/filterby/Purchaseorderlist",},
      {id:11,name: "Bills", href: "/crm/filterby/Billslist"},
    ],
  },
  {
    id:10,
    name: "Inventory",
    current: false,
    defaultOpen:"",
    icon: TableIcon,
    children: [
      {name: "Warehouse", href: "/crm/filterby/WarehouseList",},
      { name: "Inventory Transfer", href: "/crm/filterby/InventorytranferList",},
      {name: "Inventory Adjustments",href: "/crm/filterby/InventoryadjustmentsList",},
      {name: "FIFO Lot Tracking", href: "/crm/filterby/Fiforeport",},
    ],
  },
  {
    id:11,
    name: "Setting",
    current: false,
    icon: CogIcon,
    defaultOpen:"",
    children: [
      { name: "Lead Source", href: "/crm/filterby/LeadsourceList" },
      { name: "Lead Status", href: "/crm/filterby/LeadstatusList" },
      { name: "Brand", href: "/crm/filterby/BrandList" },
      { name: "Manufacturer", href: "/crm/filterby/ManufacturersList" },
      { name: "Mode of Payment", href: "/crm/filterby/ModeofpaymentList" },
      { name: "Expense Category", href: "/crm/filterby/ExpensecateList" },
      { name: "Reason", href: "/crm/filterby/Reasonlist" },
      { name: "Feedback Question", href: "/crm/filterby/InvoicefeedbackquestionList" },
      { name: "Organization Profile", href: "/crm/filterby/Organizationprofile" },
    ],
  },
  
];

export default function Test() {
  return (
    <div className="w-full h-screen px-4 pt-16 bg-green-500">
      <div className="mx-auto w-[500px] h-[500px] max-w-md rounded-2xl bg-white p-2 text-lg">
        <h1 className='text-center text-4xl py-4'>FAQ</h1>
        {navigation.map((faq) => (
          <Disclosure>
            {({ open}) => (
              <>
                  <div key={faq.id}>
                    <Disclosure.Button className="flex w-full justify-between rounded-lg bg-green-200 px-4 py-3 mb-2 text-left font-medium text-green-600">
                      <span>{faq.name}</span>
                    
                    </Disclosure.Button>
                    {open && (
                      <Disclosure.Panel static className="text-gray-500 flex w-full justify-between rounded-lg px-4 mb-2 text-left text-sm font-medium">
                        {faq.name}
                      </Disclosure.Panel>
                    )}
                  </div>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  )
}